<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  [closeOnEscape]="true"
  styleClass="forum-modal animate-slide-in-up"
  [style]="{width: '95vw', maxWidth: '600px'}"
  (onHide)="onHide()">

  <!-- Custom header -->
  <ng-template pTemplate="header">
    <div class="flex justify-between items-center w-full">
      <div class="flex items-center gap-3">
        <div class="bg-primary-100 rounded-full p-2">
          <lucide-angular [img]="mapPinIcon" class="w-6 h-6 text-primary-600"></lucide-angular>
        </div>
        <div class="text-left">
          <h2 class="text-xl font-bold text-gray-800 mb-0">
            {{ 'forum.modal.title' | transloco }}
          </h2>
          <p class="text-xs text-primary-600 font-medium">
            {{ 'forum.modal.comingSoon' | transloco }}
          </p>
        </div>
      </div>
      <button
        type="button"
        (click)="onHide()"
        class="p-1 text-gray-400 hover:text-gray-600 transition-colors"
        [disabled]="isLoading">
        <lucide-angular [img]="xIcon" class="w-5 h-5"></lucide-angular>
      </button>
    </div>
  </ng-template>

  @if (!showSuccess) {

    <!-- Coming Soon Features -->
    <div class="border-b pb-6 mb-6">
      <div class="grid grid-cols-2 gap-3 text-sm">
        <div class="flex items-center gap-3">
          <div class="bg-primary-100 rounded-full p-2 flex-shrink-0">
            <lucide-angular [img]="botIcon" class="w-4 h-4 text-primary-600"></lucide-angular>
          </div>
          <span class="text-gray-700">{{ 'forum.modal.features.ai' | transloco }}</span>
        </div>
        <div class="flex items-center gap-3">
          <div class="bg-primary-100 rounded-full p-2 flex-shrink-0">
            <lucide-angular [img]="barChartIcon" class="w-4 h-4 text-primary-600"></lucide-angular>
          </div>
          <span class="text-gray-700">{{ 'forum.modal.features.analytics' | transloco }}</span>
        </div>
        <div class="flex items-center gap-3">
          <div class="bg-primary-100 rounded-full p-2 flex-shrink-0">
            <lucide-angular [img]="globeIcon" class="w-4 h-4 text-primary-600"></lucide-angular>
          </div>
          <span class="text-gray-700">{{ 'forum.modal.features.compensation' | transloco }}</span>
        </div>
        <div class="flex items-center gap-3">
          <div class="bg-primary-100 rounded-full p-2 flex-shrink-0">
            <lucide-angular [img]="linkIcon" class="w-4 h-4 text-primary-600"></lucide-angular>
          </div>
          <span class="text-gray-700">{{ 'forum.modal.features.integrations' | transloco }}</span>
        </div>
        <div class="flex items-center gap-3">
          <div class="bg-primary-100 rounded-full p-2 flex-shrink-0">
            <lucide-angular [img]="shieldIcon" class="w-4 h-4 text-primary-600"></lucide-angular>
          </div>
          <span class="text-gray-700">{{ 'forum.modal.features.security' | transloco }}</span>
        </div>
        <div class="flex items-center gap-3">
          <div class="bg-primary-100 rounded-full p-2 flex-shrink-0">
            <lucide-angular [img]="tagIcon" class="w-4 h-4 text-primary-600"></lucide-angular>
          </div>
          <span class="text-gray-700">{{ 'forum.modal.features.whiteLabel' | transloco }}</span>
        </div>
      </div>
    </div>

    <!-- Section Offre exclusive -->
    <div class="bg-primary-50 border border-primary-200 rounded-lg p-4 mb-6">
      <div class="flex items-center gap-2 mb-2">
        <lucide-angular [img]="giftIcon" class="w-5 h-5 text-primary-600"></lucide-angular>
        <h3 class="font-semibold text-primary-800">
          {{ 'forum.modal.offer.title' | transloco }}
        </h3>
      </div>
      <p class="text-sm text-primary-700">
        {{ 'forum.modal.offer.description' | transloco }}
      </p>
    </div>

    <!-- Formulaire -->
    <form [formGroup]="leadForm" (ngSubmit)="onSubmit()" class="mb-6">
      <!-- Première ligne: Email et Société -->
      <div class="grid grid-cols-2 gap-4 mb-4">
        <!-- Email -->
        <div class="form-group">
          <label for="email" class="block text-sm font-medium text-gray-700 mb-2">
            {{ 'forum.modal.form.email' | transloco }} *
          </label>
          <input
            pInputText
            id="email"
            formControlName="email"
            type="email"
            class="w-full transition-all duration-200 focus:-translate-y-0.5 focus:shadow-lg"
            [class.!border-red-600]="leadForm.get('email')?.invalid && leadForm.get('email')?.touched"
            [class.!shadow-red-200]="leadForm.get('email')?.invalid && leadForm.get('email')?.touched"
            [placeholder]="'forum.modal.form.emailPlaceholder' | transloco">
          
          @if (leadForm.get('email')?.invalid && leadForm.get('email')?.touched) {
            <small class="block mt-1 text-red-600 text-sm font-medium">
              {{ 'forum.modal.form.emailError' | transloco }}
            </small>
          }
        </div>

        <!-- Société -->
        <div class="form-group">
          <label for="company" class="block text-sm font-medium text-gray-700 mb-2">
            {{ 'forum.modal.form.company' | transloco }} *
          </label>
          <input
            pInputText
            id="company"
            formControlName="company"
            type="text"
            class="w-full transition-all duration-200 focus:-translate-y-0.5 focus:shadow-lg"
            [class.!border-red-600]="leadForm.get('company')?.invalid && leadForm.get('company')?.touched"
            [class.!shadow-red-200]="leadForm.get('company')?.invalid && leadForm.get('company')?.touched"
            [placeholder]="'forum.modal.form.companyPlaceholder' | transloco">
          
          @if (leadForm.get('company')?.invalid && leadForm.get('company')?.touched) {
            <small class="block mt-1 text-red-600 text-sm font-medium">
              {{ 'forum.modal.form.companyError' | transloco }}
            </small>
          }
        </div>
      </div>

      <!-- Deuxième ligne: Voyages par an et Type d'organisation -->
      <div class="grid grid-cols-2 gap-4 mb-4">
        <!-- Nombre de voyages par an -->
        <div class="form-group">
          <label for="tripsPerYear" class="block text-sm font-medium text-gray-700 mb-2">
            {{ 'forum.modal.form.tripsPerYear' | transloco }}
          </label>
          <input
            pInputText
            id="tripsPerYear"
            formControlName="tripsPerYear"
            type="number"
            min="0"
            class="w-full transition-all duration-200 focus:-translate-y-0.5 focus:shadow-lg"
            [placeholder]="'forum.modal.form.tripsPerYearPlaceholder' | transloco">
        </div>

        <!-- Type d'organisation -->
        <div class="form-group">
          <label for="organizationType" class="block text-sm font-medium text-gray-700 mb-2">
            {{ 'forum.modal.form.organizationType' | transloco }}
          </label>
          <p-select
            id="organizationType"
            formControlName="organizationType"
            [options]="organizationTypeOptions"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'forum.modal.form.organizationTypePlaceholder' | transloco"
            styleClass="w-full"
            appendTo="body">
          </p-select>
        </div>
      </div>

      <!-- Message d'erreur -->
      @if (errorMessage) {
        <div class="p-3 bg-red-50 border border-red-200 rounded-md">
          <p class="text-sm text-red-600">{{ errorMessage }}</p>
        </div>
      }
    </form>

    <!-- Boutons -->
    <div class="flex justify-end items-center gap-4 pt-4">
      <p-button
        type="button"
        (click)="onSkip()"
        [text]="true"
        severity="secondary"
        [label]="'forum.modal.form.skipButton' | transloco"
        [disabled]="isLoading"
      />

      <p-button
        type="submit"
        [label]="'forum.modal.form.submitButton' | transloco"
        [loading]="isLoading"
        [disabled]="leadForm.invalid"
        (onClick)="onSubmit()">
      </p-button>
    </div>

  } @else {
    <!-- Message de succès -->
    <div class="text-center py-8">
      <div class="flex justify-center mb-4">
        <div class="bg-primary-100 rounded-full p-3">
          <lucide-angular [img]="usersIcon" class="w-8 h-8 text-primary-600"></lucide-angular>
        </div>
      </div>
      
      <h3 class="text-xl font-bold text-primary-800 mb-3">
        {{ 'forum.modal.success.title' | transloco }}
      </h3>
      
      <p class="text-gray-600 mb-6">
        {{ 'forum.modal.success.message' | transloco }}
      </p>
      
      <div class="flex justify-center">
        <div class="flex items-center gap-2 text-primary-600 font-medium">
          <lucide-angular [img]="leafIcon" class="w-5 h-5"></lucide-angular>
          <span>{{ 'forum.modal.success.thanks' | transloco }}</span>
        </div>
      </div>
    </div>
  }
</p-dialog>